module.exports = __webpack_public_path__ + "static/media/fishtacos.76af3e59.png";